export default {
    manage_createEditDriverStatus_EditTitle: "Editar Estado de Conductor:",
    manage_createEditDriverStatus_CreateTitle: "Crear Estado de Conductor",
    manage_createEditDriverStatus_success: "Estado de Conductor creado exitosamente",
    manage_createEditDriverStatus_success_edit: "Estado de Conductor actualizado exitosamente",
    manage_createEditDriverStatus_duplicatedDriverStatusErrorMessage: "Este Estado de Conductor ya existe",
    manage_createEditDriverStatus_NameInputLabel: "Nombre",
    manage_createEditDriverStatus_AccumulateTimeLabel: "Acumular Tiempo"
}